module.exports = __webpack_public_path__ + "static/img/Tela de importar xml.bd39605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de importar xml.png
// module id = gB2q
// module chunks = 0